import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import {Modal, message,Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([

    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'itemName', 
        width: 200, 
        label: '依据名称'
    },
    {
        key:'itemDetailVOs', 
        label: '量化指标', 
        width: 240, 
        render: (data) => {
            return  data?(
                data.map((d) => (
                    <div>
                        <Tag color='#1890ff'>{d.columnName}</Tag>：{d.companyName ? d.value +"/"+ d.companyName  : d.value }
                    </div>
                ))
            ):''
        }
    },
    {
        key: 'itemTypeName', 
        label: '依据类型'
    },
    {
        key: 'isNeedFilling', 
        label: '是否必填', 
        render: (showScore) => {
            if(showScore === 1) {
                return '必填';
            } else  {
                return '非必填';
            } 
        } 
    },
    {
        key: 'isUpload', 
        label: '是否上传附件',
        render: (isUpload) => {
            if(isUpload === 1) {
                return '上传';
            } else {
                return '不上传';
            } 
        } 
    }
]);

/**
 * @method getColumnsById
 * @param {number} id
 * @return {promise}
 */
 const getColumnsById = (id) => {
    return fetch.get('supv/category/items/getColumnsById/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('/supv/category/items/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('/supv/category/items/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data.dataList || []).map(item => {
                return Object.assign({}, item, {
                    height: (item.itemDetailVOs || []).length * 30
                })
            }),
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
                height: (d.itemDetailVOs || []).length * 30
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }));

        return list;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('/supv/category/items/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '分类依据添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到分类依据管理页面！</p>
                    </div>
                ),
                onOk() {
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('/supv/category/items/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '评价依据更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到评价依据管理页面！</p>
                    </div>
                ),
                onOk() {
                    
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('/supv/category/items/remove/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    redirect,
    getColumnsById
}